import {Link} from 'react-router-dom'

const CommaList = ({nameDescList, inline, join, info}) => {

    return (
        <span>
            {
                // ?
                nameDescList?.map((elem, index)=>{
                    const description=elem.Description!=='-'?elem.Description:'';
                    const comma=(index < nameDescList.length-1)? join?join:',': '';
                    const className=description?'hasTitle':'';

                    return (
                        <span key={index}>
                        <span className={className} title={description}> 
                        {!elem.URL && 
                           <span> {elem.Name.trim()} 
                           { info && description &&
                            <sup className="sup" style={{cursor: 'help',marginLeft:3, color: "#425BA6", fontWeight: 'bold'}}>ⓘ</sup>
                           }
                           </span>
                        }
                        {elem.URL && 
                           <a href={elem.URL} target="_blank"> {elem.Name.trim()}
                           </a>
                        }
                        </span>{comma}
                        </span>
                    )
                })
            }
        </span>
    )
}

// { f.Key == 'actcat' && 
// <a className="show-more" onClick={handleShowMore}>
//   {showAllActivities?'Pokaż mniej':'Pokaż więcej'}
// </a>
// }

export default CommaList;